import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { first, map, takeUntil } from 'rxjs/operators'
import { forkJoin, Observable, of, Subject } from 'rxjs'

import { ConfirmUnsavedChanges } from '@core/guards/unsaved-changes.guard'
import { ClientsService } from '@app/modules/admin/clients/clients.service'
import { Driver } from '@app/shared/models/driver.model'
import { AuthService } from '@app/modules/auth/auth.service'
import { DocumentService } from '../documents/document.service'
import { DriverDocumentItem } from '../documents/document.model'
import { DocumentFormComponent } from '../documents/document-form.component'

@Component({
  selector: 'lin-driver-document-save',
  templateUrl: './driver-document-save.component.html',
  standalone: false,
})
export class DriverDocumentSaveComponent implements OnInit, OnDestroy, ConfirmUnsavedChanges {
  sectionTitle: string
  driver: Driver
  clientId: number

  isLoaded = false
  document = null

  @ViewChild(DocumentFormComponent) private formComponent: DocumentFormComponent
  private readonly onDestroy$ = new Subject<void>()

  constructor(
    private route: ActivatedRoute,
    private clientsService: ClientsService,
    private documentService: DocumentService,
    private authService: AuthService,
  ) {}

  ngOnInit() {
    this.authService.currentUser$.pipe(first()).subscribe((user) => (this.clientId = user.team.clientId))
    const { paramMap } = this.route.snapshot
    const driverId = paramMap.get('id')
    const documentId = +paramMap.get('documentId')

    this.sectionTitle = documentId ? 'CLIENT.VEHICLES.DOCUMENTS.EDIT' : 'CLIENT.VEHICLES.DOCUMENTS.ADD_NEW'

    const toTransformedDocument = (document: DriverDocumentItem) => ({ ...document, driver: new Driver(document.driver) })
    const document$ = documentId
      ? this.documentService.get(documentId).pipe(map(toTransformedDocument), takeUntil(this.onDestroy$))
      : of(null)
    const driver$ = driverId
      ? <Observable<Driver>>this.clientsService.getClientUser(this.clientId, +driverId).pipe(takeUntil(this.onDestroy$))
      : of(null)

    forkJoin([document$, driver$])
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(([document, driver]) => {
        this.document = document
        this.driver = driver

        this.isLoaded = true
      })
  }

  hasUnsavedChanges() {
    return !!this.formComponent && this.formComponent.hasUnsavedChanges()
  }

  ngOnDestroy() {
    this.onDestroy$.next()
    this.onDestroy$.complete()
  }
}
